export default (url) => {
    if (url !== null && url !== undefined) {
        const newurl = url.replace(
            'eggapp-resources/profile-images/',
            'eggapp-resources%2Fprofile-images%2F'
        )
        return newurl
    }
}
